import { motion } from "framer-motion";
import { ArrowRight, Users } from "lucide-react";

const DALLAS_BG = "https://images.unsplash.com/photo-1696270804660-c31be43dbc69?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85";

const fadeUp = (delay = 0) => ({
  initial: { opacity: 0, y: 30 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.7, delay },
});

const HeroSection = ({ onGetEarlyAccess }) => {
  return (
    <section className="relative min-h-screen flex flex-col items-center justify-center text-center px-6 py-24 overflow-hidden">
      {/* Dallas skyline backdrop */}
      <div
        className="absolute inset-0 z-0 bg-cover bg-center"
        style={{
          backgroundImage: `url(${DALLAS_BG})`,
          opacity: 0.07,
        }}
      />

      {/* Dark overlay */}
      <div className="absolute inset-0 z-0 bg-[#0D0D11]/80" />

      {/* Animated gradient glow blob */}
      <div
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[350px] rounded-full z-0 animate-[glow-pulse_4s_ease-in-out_infinite]"
        style={{
          background: "linear-gradient(135deg, #FF641E 0%, #A25AFF 100%)",
          filter: "blur(120px)",
          opacity: 0.28,
        }}
      />

      {/* Content */}
      <div className="relative z-10 max-w-5xl mx-auto flex flex-col items-center">
        <motion.p
          {...fadeUp(0)}
          className="font-manrope text-xs sm:text-sm tracking-[0.25em] uppercase text-[#A25AFF] font-bold mb-6"
        >
          Dallas · Community Intelligence · Coming Soon
        </motion.p>

        <motion.h1
          {...fadeUp(0.1)}
          className="font-oswald text-5xl sm:text-7xl lg:text-8xl font-bold tracking-tight leading-[1.05] text-[#F0F0EE] mb-8"
        >
          The restaurants Dallas<br />
          <span
            className="text-transparent bg-clip-text"
            style={{ backgroundImage: "linear-gradient(90deg, #FF641E 30%, #A25AFF 100%)" }}
          >
            is actually talking about.
          </span>
        </motion.h1>

        <motion.p
          {...fadeUp(0.2)}
          className="font-manrope text-base sm:text-lg leading-relaxed text-[#8A8A93] max-w-2xl mb-12"
        >
          Znipd turns community conversations in Facebook Groups and Reddit into a
          real-time restaurant directory — powered by the people who actually eat there.
        </motion.p>

        <motion.div
          {...fadeUp(0.3)}
          className="flex flex-col sm:flex-row gap-4 items-center justify-center w-full"
        >
          <button
            data-testid="hero-primary-cta"
            onClick={onGetEarlyAccess}
            className="flex items-center gap-2 bg-[#FF641E] text-[#0D0D11] font-manrope font-bold px-8 py-4 rounded-md hover:opacity-90 hover:scale-105 transition-all duration-300 text-base"
          >
            Get Early Access
            <ArrowRight size={18} />
          </button>

          <a
            data-testid="hero-secondary-cta"
            href="https://www.facebook.com/znipd/"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 border-2 border-[#A25AFF] text-[#F0F0EE] font-manrope font-bold px-8 py-4 rounded-md hover:bg-[#A25AFF]/10 transition-colors duration-300 text-base"
          >
            <Users size={18} className="text-[#A25AFF]" />
            Join the Community
          </a>
        </motion.div>
      </div>

      {/* Subtle bottom fade */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-[#0D0D11] to-transparent z-10" />
    </section>
  );
};

export default HeroSection;
